export default __webpack_public_path__ + "static/media/6_eficiencia.2e371b6b.svg";